<template>
  <svg :class="svgClass" aria-hidden="true" @click="clickAction" title="">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
export default {
  name: "svg-icon",
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return "svg-icon " + this.className;
      } else {
        return "svg-icon";
      }
    }
  },
  methods: {
    clickAction() {
      this.$emit("click");
    }
  }
};
</script>

<style>
.svg-icon {
  width: 14px;
  height: 14px;
  vertical-align: -0.15em;
  overflow: hidden;
}

svg:focus {
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/SvgIcon/SvgIcon.vue